import { createFileRoute, notFound } from "@tanstack/react-router";

import { LocalePage } from "@/components/locale/LocalePage";
import { localeHead } from "@/lib/locales/head";
import { findPageBySlug, isLocaleCode } from "@/lib/locales";
import { publicPageHeaders } from "@/lib/http-cache";

export const Route = createFileRoute("/$locale/$slug")({
  headers: publicPageHeaders,
  beforeLoad: ({ params }) => {
    if (!isLocaleCode(params.locale)) throw notFound();
    if (!findPageBySlug(params.locale, params.slug)) throw notFound();
  },
  head: ({ params }) => {
    if (!isLocaleCode(params.locale)) return {};
    const key = findPageBySlug(params.locale, params.slug);
    return key ? localeHead(params.locale, key) : {};
  },
  component: LocaleSlugPage,
});

function LocaleSlugPage() {
  const { locale, slug } = Route.useParams();
  if (!isLocaleCode(locale)) return null;
  const key = findPageBySlug(locale, slug);
  if (!key) return null;
  return <LocalePage code={locale} pageKey={key} />;
}
